<template>
  <div class="all-whole">
    <navCom :navActive="navActive"></navCom>
    <div class="w clearfix" >
      <!--左侧导航 1start-->
      <user-nav :userNav="userNav"></user-nav>
      <!--左侧导航 end-->
      <!--右侧内容 2start-->
      <div class="user-main-right">
        <h2 class="user-order-title" v-if="order_status==0">待付款</h2>
        <h2 class="user-order-title" v-if="order_status==1">已支付</h2>
        <h2 class="user-order-title" v-if="order_status==2">已失效</h2>
        <h2 class="user-order-title" v-if="order_status==3">已退款</h2>
        <h2 class="user-order-title" v-if="order_status==4">退款申请中</h2>
        <h2 class="user-order-title" v-if="order_status==5">退款被拒绝</h2>
        <h2 class="user-order-title" v-if="order_status==6">订单已取消</h2>
        <div class="user-main-right-center">
          <ul class="order-list-detail-main">
            <li >
              <table class="main-order-table">
                <tr>
                  <th>商品详情</th>
                  <th v-if="course_type==1">上课时间</th>
                  <th>授课老师</th>
                  <th>实付金额</th>
                </tr>
                <tr>
                  <td class="order-list-title" style="max-width: 130px;">{{course_name}}</td>
                  <td style="max-width: 80px;" v-if="course_type==1">{{live_start_time}}至{{live_end_time}}</td>
                  <td style="max-width: 130px;">{{teacher_name}}</td>
                  <td style="width: 166px;">{{price}}元</td>
                </tr>
              </table>
            </li>
          </ul>
          <div class="user-main-right-btn" v-if="order_status==0">
            <p class="refund-btn" @click="cancelFun(id)">取消订单</p>

              <p class="refund-btn" @click="toPay(order_num)">立即付款</p>

          </div>
          <div class="user-main-right-btn" v-if="order_status==1">
            <p class="ok-btn" @click="refundFun(id)">申请退款</p>
          </div>
        </div>
      </div>
      <!--右侧内容 end-->
    </div>
    <footerCom></footerCom>
  </div>
</template>

<script>
  import UserNav from '.././components/user-nav.vue'
  import navCom from '../../components/welcome-nav'
  import footerCom from '../../components/foot'
  import tool from '../../assets/js/tool.js'
  import purchase from '.././payment'
  export default {
    name: "order-payment-detail",
    data(){
      return{
        order_status:'',//订单状态
        course_id:this.$route.query.course_id,//课程id
        navActive:3,
        userNav:3,
        order_id:this.$route.query.order_id,
        order_num:this.$route.query.order_num,
        course_name:'',//课程名称
        price:'',//价格
        live_start_time:'',//开始时间
        live_end_time:'',//结束时间
        course_type:'',//课程状态
        teacher_name:'',//教师名称
        id:this.$route.query.order_id,//订单id
      }
    },
    components: {
      UserNav,
      navCom,
      footerCom
    },
    methods:{
      getOrder () {
        let data = {
          user_id:this.$store.state.uuid,
          order_id:this.order_id
        };
        tool.postData('Center_Order/orderDetails', data,(res) => {
          this.course_name=res.data.data.course_name;
          this.price=res.data.data.price;
          this.live_start_time=res.data.data.live_start_time;
          this.live_end_time=res.data.data.live_end_time;
          this.order_status=res.data.data.order_status;
          this.course_type=res.data.data.course_type;
          this.teacher_name=res.data.data.teacher_name;
          this.id=res.data.data.id;
          this.course_id=res.data.data.course_id;
          this.order_num=res.data.data.order_num;
          if(this.order_status===0){
           this.userNav=8
          } if(this.order_status===1){
            this.userNav=9
          } if(this.order_status===2){
            this.userNav=7
          } if(this.order_status===3){
            this.userNav=10
          } if(this.order_status===4||this.order_status===5){
            this.userNav=10
          } if(this.order_status===6){
            this.userNav=7
          }
        })

      },
      refundFun(id){
        this.$router.push({
          path: `/user/order-refund`,
          query: {
            order_id: id
          },
        });
      },
      toPay(id){
        this.$router.push({
          name: 'purchase-course',
          component: purchase,
          query: {
            order_num: this.order_num,
            navActive:10
          },
        });
      },
      cancelFun(id){
        let data = {
          user_id:this.$store.state.uuid,
          order_id:this.order_id
        };
        tool.postData('Center_Order/cancelOrder', data,(res) => {
          this.getOrder()
        })
      },
    },
    mounted(){
      this.getOrder();
    }
  }
</script>

<style scoped>
  .w{
    width: 1200px;
    margin:0 auto ;
  }
  .fl{
    float: left;
  }
  .fr{
    float: right;
  }
  .all-whole{
    background: #fbfbfb;
    height: 100%;
  }
  .user-main-right{
    width: 1000px;
    float: right;
    height: 895px;
    background: #ffffff;
  }
  .user-order-title{
    width: 100%;
    height: 70px;
    line-height: 100px;
    box-sizing: border-box;
    border-bottom: 1px solid #e3e3e3;
    font-size: 18px;
    color: #252525;
    padding-left: 20px;
    font-weight: 500;
    margin-bottom: 23px;
  }
  .user-main-right-center{
    width: 954px;
    margin: 0 26px;
  }
  .user-main-right{
    width: 1000px;
    float: right;
    padding-bottom: 280px;
    box-sizing: border-box;
  }
  .user-order-title{
    width: 100%;
    border-bottom: 1px solid #e3e3e3;
    padding-bottom: 17px;
    font-size: 16px;
    color: #252525;
    font-weight: 500;
  }
  .main-order-title p{
    font-size: 14px;
    color: #2ea6a5;
    line-height: 65px;
  }
  .main-order-title span{
    font-size: 14px;
    color: #5c5c5c;
    line-height: 65px;
  }
  .main-order-table{
    width: 100%;
    border: 1px solid #e3e3e3;
    border-spacing: 0;
  }
  .main-order-table tr th{
    height: 47px;
    background: #f3f3f3;
    text-align: center;
    font-size: 14px;
    color: #717171;
    border-bottom: 1px solid #e3e3e3;
  }
  .main-order-table tr td{
    text-align: center;
    min-height: 58px;
    font-size: 14px;
    color: #8c8c8c;
    border-right: 1px solid #e3e3e3;
    padding: 15px 0;
  }
  .main-order-table tr td p{
    line-height: 20px;
  }
  .main-order-table tr td:last-child{
    border-right: none;
  }
  .main-order-table tr td.order-list-title{
    color: #414141;
    font-weight: 600;
  }
  .order-pay-btn span{
    width: 100px;
    height: 40px;
    line-height: 40px;
    font-size: 16px;
    text-align: center;
    border-radius: 7px;
    color: #fff;
  }
  .refund-btn{
    height: 40px;
    width:90px;
    color: #fff;
    line-height: 40px;
    text-align: center;
    font-size: 16px;
    border-radius: 5px;
    float: right;
    margin-top: 70px;
    border: none;
    outline: none;
    cursor: pointer;
  }
  .refund-btn:first-child{
    background-color: #e3e3e3;
  }
  .refund-btn:last-child{
    background-color: #ff9919;
    margin-right:30px;
  }
  .ok-btn{
    background-color:#8c8c8c;
    height: 40px;
    width:90px;
    color: #fff;
    line-height: 40px;
    text-align: center;
    font-size: 16px;
    border-radius: 5px;
    float: right;
    margin-top: 70px;
    border: none;
    outline: none;
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/pages/user/order-payment-detail.vue